import { Observable } from 'rxjs';
import { GenericService } from './../generic.service';
import { Injectable } from '@angular/core';
import { studentRecommendationRequest } from '../../models/recommendation/studentRecommendationRequest';
import { StudentDocumentResponse } from '../../models/document/studentDocumentResponse';
import { StudentRecommendationResponse } from '../../models/recommendation/studentRecommendationResponse';

@Injectable({
  providedIn: 'root'
})
export class RecommendationService {
  constructor(private genericService: GenericService) {

  }

  addRecommendation(recommRequest: studentRecommendationRequest): Observable<StudentRecommendationResponse> {
    return this.genericService.post('recommendation',recommRequest);
  }

  getRecommendation(): Observable<StudentRecommendationResponse> {
    return this.genericService.get('recommendation');
  }

  updateRecommendation(recommRequest: studentRecommendationRequest): Observable<StudentRecommendationResponse> {
    return this.genericService.put('recommendation',recommRequest);
  }
}
